<template>
  <div class="stock-sector-query">
    <div class="page-header">
      <div class="page-title">
        <div class="title-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <h1>板块选股</h1>
        <div class="title-decoration"></div>
      </div>
      <p class="page-subtitle">按行业板块和概念板块筛选股票</p>
    </div>

    <div class="filter-bar">
      <el-radio-group v-model="sectorType" @change="handleSectorTypeChange" class="sector-type-group">
        <el-radio-button :label="null">全部</el-radio-button>
        <el-radio-button :label="2">行业板块</el-radio-button>
        <el-radio-button :label="1">概念板块</el-radio-button>
      </el-radio-group>

      <el-select
        v-model="selectedBoard"
        placeholder="选择板块"
        filterable
        clearable
        class="board-select"
        :loading="boardLoading"
        @change="handleBoardChange"
      >
        <el-option
          v-for="item in boardList"
          :key="item.board_code"
          :label="`${item.board_name} (${item.stock_count})`"
          :value="item.board_code"
        >
          <span style="float: left">{{ item.board_name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.stock_count }}</span>
        </el-option>
      </el-select>

      <el-button type="primary" @click="fetchStocks" :loading="stocksLoading" :disabled="!selectedBoard">
        <i class="el-icon-search"></i>
        <span>查询股票</span>
      </el-button>
    </div>

    <div class="stock-count" v-if="selectedBoard">
      共 <strong>{{ total }}</strong> 只股票
    </div>

    <el-table
      :data="stockList"
      v-loading="stocksLoading"
      border
      stripe
      style="width: 100%"
      class="stock-table"
    >
      <el-table-column prop="stock_code" label="股票代码" width="100">
      </el-table-column>
      <el-table-column prop="stock_name" label="股票名称" width="120">
      </el-table-column>
      <el-table-column prop="exchange" label="交易所" width="70">
        <template slot-scope="scope">
          <el-tag :type="getExchangeType(scope.row.exchange)" size="small">
            {{ scope.row.exchange }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="exchange_board" label="板块" width="85">
      </el-table-column>
      <el-table-column prop="is_main_board" label="主板" width="70" align="center">
        <!-- <template slot-scope="scope">
          <el-tag :type="scope.row.is_main_board ? 'success' : 'info'" size="small">
            {{ scope.row.is_main_board ? '是' : '否' }}
          </el-tag>
        </template> -->
      </el-table-column>
      <!-- <el-table-column prop="stock_code" label="股票代码" width="120">
      </el-table-column> -->
      <el-table-column prop="board_name" label="所属板块" width="150">
      </el-table-column>
      <el-table-column label="板块类型" width="85" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.sector_type === 2 ? 'warning' : 'primary'" size="small">
            {{ scope.row.sector_type === 2 ? '行业' : '概念' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="最新收盘价" width="110" align="right">
        <template slot-scope="scope">
          <span :class="getValueClass(scope.row.latest_close, scope.row.min_close_100d, scope.row.max_close_100d)">
            {{ formatPrice(scope.row.latest_close) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Max100" width="90" align="right">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.max_close_100d) }}
        </template>
      </el-table-column>
      <el-table-column label="Min100" width="90" align="right">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.min_close_100d) }}
        </template>
      </el-table-column>
      <el-table-column label="Max Ratio" width="90" align="right">
        <template slot-scope="scope">
          <span :class="getRatioClass(scope.row.max_close_100d, scope.row.latest_close)">
            {{ formatRatio(scope.row.max_close_100d, scope.row.latest_close) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Min Ratio" width="90" align="right">
        <template slot-scope="scope">
          <span :class="getRatioClass(scope.row.min_close_100d, scope.row.latest_close)">
            {{ formatRatio(scope.row.min_close_100d, scope.row.latest_close) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click.stop="copyStockCode(scope.row)"
          >
            复制
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="addToFavorite(scope.row)"
            :loading="scope.row.adding"
          >
            自选
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'day')"
          >
            日K
          </el-button>
          <el-button
            type="text"
            size="small"
            @click.stop="viewKLine(scope.row, 'week')"
          >
            周K
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StockSectorQuery',
  data() {
    return {
      sectorType: null,
      boardList: [],
      selectedBoard: '',
      boardLoading: false,
      stockList: [],
      stocksLoading: false,
      total: 0
    }
  },
  mounted() {
    this.fetchBoards()
  },
  methods: {
    async fetchBoards() {
      this.boardLoading = true
      try {
        const params = {}
        if (this.sectorType) {
          params.sector_type = this.sectorType
        }

        const response = await axios.get('/stock/sector/boards', { params })
        console.log('板块列表接口返回:', response.data)

        if (response.data && response.data.status === 'success') {
          this.boardList = response.data.data || []
          console.log('板块数量:', this.boardList.length)
        } else {
          this.boardList = []
          this.$message.error('获取板块列表失败')
        }
      } catch (error) {
        console.error('获取板块列表失败:', error)
        this.$message.error('获取板块列表失败')
        this.boardList = []
      } finally {
        this.boardLoading = false
      }
    },

    async fetchStocks() {
      if (!this.selectedBoard) {
        this.$message.warning('请先选择板块')
        return
      }

      this.stocksLoading = true
      try {
        const params = {
          board_code: this.selectedBoard
        }
        if (this.sectorType) {
          params.sector_type = this.sectorType
        }

        const response = await axios.get('/stock/sector/stocks', { params })
        console.log('板块股票接口返回:', response.data)

        if (response.data && response.data.status === 'success') {
          this.stockList = response.data.data || []
          this.total = this.stockList.length
          console.log('股票数量:', this.total)
        } else {
          this.stockList = []
          this.total = 0
          this.$message.error('获取股票列表失败')
        }
      } catch (error) {
        console.error('获取股票列表失败:', error)
        this.$message.error('获取股票列表失败')
        this.stockList = []
        this.total = 0
      } finally {
        this.stocksLoading = false
      }
    },

    handleSectorTypeChange() {
      this.selectedBoard = ''
      this.stockList = []
      this.total = 0
      this.fetchBoards()
    },

    handleBoardChange() {
      if (this.selectedBoard) {
        this.fetchStocks()
      } else {
        this.stockList = []
        this.total = 0
      }
    },

    viewKLine(row, type) {
      const code = row.stock_code || row.stock_code
      const routeMap = {
        'day': '/kline/day',
        'week': '/kline/week',
        '5min': '/kline/5min'
      }
      this.$router.push({
        path: routeMap[type],
        query: { code }
      })
    },

    copyStockCode(row) {
      const code = row.stock_code || row.simple_code
      navigator.clipboard.writeText(code).then(() => {
        this.$message.success(`已复制: ${code}`)
      }).catch(err => {
        console.error('复制失败:', err)
        this.$message.error('复制失败')
      })
    },

    async addToFavorite(row) {
      this.$set(row, 'adding', true)
      try {
        const response = await axios.post('/stock/favorite/add', {
          user_id: '1',
          stock_code: row.stock_code || row.simple_code,
          stock_name: row.stock_name
        })

        if (response.data && response.data.message && response.data.message.includes('添加成功')) {
          this.$message.success(`已将 ${row.stock_name} 添加到自选`)
        } else if (response.data && response.data.message && response.data.message.includes('已存在')) {
          this.$message.info(`${row.stock_name} 已在自选中`)
        } else {
          this.$message.error('添加失败')
        }
      } catch (error) {
        console.error('添加自选失败:', error)
        if (error.response?.data?.message) {
          if (error.response.data.message.includes('已存在') || error.response.data.message.includes('already exists')) {
            this.$message.info(`${row.stock_name} 已在自选中`)
          } else {
            this.$message.error('添加失败: ' + error.response.data.message)
          }
        } else {
          this.$message.error('添加自选失败')
        }
      } finally {
        this.$set(row, 'adding', false)
      }
    },

    getExchangeType(exchange) {
      const typeMap = {
        'sh': 'danger',
        'sz': 'success',
        'bj': 'warning'
      }
      return typeMap[exchange] || 'info'
    },

    formatPrice(value) {
      if (!value && value !== 0) return '-'
      return Number(value).toFixed(2)
    },

    getValueClass(current, min, max) {
      if (!current || !min || !max) return ''
      if (current === min) return 'value-down'
      if (current === max) return 'value-up'
      return ''
    },

    formatRatio(numerator, denominator) {
      if (!numerator || !denominator || denominator === 0) return '-'
      const ratio = Number(numerator) / Number(denominator)
      return ratio.toFixed(3)
    },

    getRatioClass(numerator, denominator) {
      if (!numerator || !denominator || denominator === 0) return ''
      const ratio = Number(numerator) / Number(denominator)
      // 最大值/最新值：比例 > 1 表示当前价低于最高价（风险）
      // 最小值/最新值：比例 > 1 表示当前价高于最低价（安全）
      if (ratio > 1) return 'ratio-high'
      if (ratio < 1) return 'ratio-low'
      return 'ratio-equal'
    }
  }
}
</script>

<style scoped>
.stock-sector-query {
  padding: 20px;
  min-height: calc(100vh - 104px);
  position: relative;
}

.page-header {
  text-align: center;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
}

.title-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b5cf6;
  border: 1px solid rgba(139, 92, 246, 0.3);
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.15);
}

.title-icon svg {
  width: 24px;
  height: 24px;
}

.page-title h1 {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 50%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.title-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #6366f1 50%, transparent 100%);
  border-radius: 2px;
}

.page-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  letter-spacing: 0.5px;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  position: relative;
  z-index: 1;
}

.sector-type-group :deep(.el-radio-button__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #e2e8f0;
  transition: all 0.3s ease;
}

.sector-type-group :deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-color: #6366f1;
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
}

.board-select {
  width: 350px;
}

.board-select :deep(.el-input__inner) {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(99, 102, 241, 0.2);
  color: #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.board-select :deep(.el-input__inner):hover {
  border-color: rgba(99, 102, 241, 0.4);
}

.board-select :deep(.el-input__inner):focus {
  border-color: #6366f1;
  box-shadow: 0 0 16px rgba(99, 102, 241, 0.25);
}

.filter-bar :deep(.el-button--primary) {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-bar :deep(.el-button--primary):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(99, 102, 241, 0.45);
}

.filter-bar :deep(.el-button--primary:disabled) {
  background: rgba(99, 102, 241, 0.2);
  box-shadow: none;
  cursor: not-allowed;
}

.stock-count {
  margin-bottom: 16px;
  color: #94a3b8;
  font-size: 14px;
  padding: 10px 16px;
  background: rgba(139, 92, 246, 0.08);
  border-radius: 8px;
  border-left: 3px solid #8b5cf6;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.stock-count strong {
  color: #a78bfa;
  font-weight: 600;
}

.stock-table {
  margin-bottom: 20px;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(15, 23, 42, 0.3);
}

.stock-table :deep(.el-table__header-wrapper) {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px 12px 0 0;
}

.stock-table :deep(.el-table__header th) {
  background: rgba(30, 41, 59, 0.8) !important;
  color: #cbd5e1;
  font-weight: 600;
  border-bottom: 1px solid rgba(139, 92, 246, 0.2);
  padding: 14px 0;
}

.stock-table :deep(.el-table__body) {
  background: rgba(15, 23, 42, 0.5);
}

.stock-table :deep(.el-table__body tr) {
  background: rgba(30, 41, 59, 0.4) !important;
  transition: all 0.25s ease;
}

.stock-table :deep(.el-table__body tr.el-table__row--striped) {
  background: rgba(30, 41, 59, 0.25) !important;
}

.stock-table :deep(.el-table__body tbody tr:hover > td) {
  background: rgba(139, 92, 246, 0.08) !important;
}

.stock-table :deep(.el-table__body td) {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #e2e8f0;
  padding: 12px 0;
}

.stock-table :deep(.el-table__body-wrapper) {
  background: rgba(15, 23, 42, 0.3);
  border-radius: 0 0 16px 16px;
}

.stock-table :deep(.el-button--text) {
  color: #a5b4fc;
  transition: all 0.2s ease;
}

.stock-table :deep(.el-button--text:hover) {
  color: #c7d2fe;
  text-shadow: 0 0 8px rgba(165, 180, 252, 0.4);
}

.stock-table :deep(.el-tag--small) {
  height: 24px;
  line-height: 22px;
  padding: 0 8px;
}

/* 价格涨跌样式 */
.value-up {
  color: #ef4444;
  font-weight: 600;
}

.value-down {
  color: #22c55e;
  font-weight: 600;
}

/* 比例值样式 */
.ratio-high {
  color: #22c55e;
  font-weight: 600;
}

.ratio-low {
  color: #ef4444;
  font-weight: 600;
}

.ratio-equal {
  color: #94a3b8;
  font-weight: 600;
}
</style>
